import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LOGO =
    "https://customer-assets-jt897jd0.emergentagent.net/job_b27ff44d-5001-4718-90bb-7f512a6d425a/artifacts/bkw34fsr_4B0C15C0-DB1B-4AE6-B2B8-3386D3826D16.png";

export const Intro = ({ onDone }) => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        const t = setTimeout(() => {
            setShow(false);
            document.body.style.overflow = "";
            if (onDone) onDone();
        }, 2400);
        return () => {
            clearTimeout(t);
            document.body.style.overflow = "";
        };
    }, [onDone]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="intro-overlay"
                    className="fixed inset-0 z-[120] flex flex-col items-center justify-center bg-[#F7F9FC]"
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
                >
                    <motion.img
                        src={LOGO}
                        alt="Footman Digital Solutions"
                        className="w-28 h-28 sm:w-36 sm:h-36 rounded-2xl"
                        initial={{ opacity: 0, scale: 0.82, filter: "blur(10px)" }}
                        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    />
                    <span className="mt-6 block overflow-hidden">
                        <motion.span
                            className="block font-mono text-[11px] sm:text-xs uppercase tracking-[0.5em] text-slate-600"
                            initial={{ y: "120%" }}
                            animate={{ y: "0%" }}
                            transition={{ duration: 0.8, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
                        >
                            Your Vision. Online.
                        </motion.span>
                    </span>
                    <motion.div
                        className="mt-8 h-px w-40 origin-left bg-gradient-to-r from-sky-400 to-[#0066FF]"
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        transition={{ duration: 1.7, delay: 0.35, ease: "easeInOut" }}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
};
